import { Component, OnInit, inject, effect, Signal } from '@angular/core';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { SetTagNotFound } from '../store/app.actions';
import { environment } from '../environments/environment';
import { PrivacyService } from './services/privacy.service';
import { CookieConsentComponent } from './components/cookie-consent/cookie-consent.component';
import { Product } from '../store/app.model';
import { AppStateSelectors } from '../store/app.selectors';

@Component({
  selector: 'app-root',
  imports: [
    RouterModule,
    CookieConsentComponent
  ],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly store = inject(Store);
  private readonly privacyService = inject(PrivacyService);

  product$: Signal<Product | null> = this.store.selectSignal(AppStateSelectors.getProduct);

  constructor() {
    // React to consent changes
    effect(() => {
      console.log('🔍 product', this.product$()?.organization);
      const consent = this.privacyService.consent();
      if (consent?.cookies) {
        const gtag = this.product$()?.organization?.gtag;
        if (gtag === null || gtag === '') {
          this.loadGAScript(environment.googleAnalyticsId);
        } else {
          this.loadGAScript(gtag!);
        }
      }
    });
  }


  ngOnInit(): void {
    // Check for tag-not-found parameter in the URL
    this.activatedRoute.queryParams.subscribe(params => {
      const isTagNotFound = params['tag-not-found'] === 'true';
      if (isTagNotFound) {
        this.store.dispatch(new SetTagNotFound(true));
      }
    });

    // GA loading moved to effect/constructor
  }

  loadGAScript(measurementId: string) {
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${measurementId}', { debug_mode: ${!environment.production} });
    `;
    document.head.appendChild(script2);
  }
}
